import BatteriesText from './batteriesText';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function LFPBatteries() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`LFP-Batteries ${css.LFPBatteries}`}>
            <div className="LFPBox">
                <p className="title1">{t('presale.product.modals.LFPBatteries_title1')}</p>
                <p className="title2">{t('presale.product.modals.LFPBatteries_title2')}</p>
                <div className="top">
                    <BatteriesText className="left" />
                    <BatteriesText className="right" />
                </div>
                <BatteriesText className="bottom" />
            </div>
        </div>
    );
}
